import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
/**
 * fc-doubleæ°å¼
 * 
 * éè¿é¼ æ æé®çï¼è¾å¥èå´åçæ°å¼ã
 * 
 * å½éè¦è·åæ åæ°å¼æ¶ã
 * 
 */
@Component({
    selector: 'fc-double',
    template: `
    <nz-input-number *ngIf="fcShowLabel==='N'" [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzSize]="fcSize" 
        [nzDisabled]="_disabled" [nzPlaceHolder]="fcPlaceHolder" [ngClass]="{'fc-readonly':_readonly}" [nzMax]="_maxValue" 
        [nzMin]="_minValue"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)"  [nzStep]="fcStep">
    </nz-input-number>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-input-number style="width:100%;" [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" 
                    [nzSize]="fcSize" [nzMax]="_maxValue" [nzMin]="_minValue" [ngClass]="{'fc-readonly':_readonly}" 
                    [nzDisabled]="_disabled" [nzPlaceHolder]="fcPlaceHolder"  (blur)="_blur($event)" (focus)="_focus($event)"  (click)="_click($event)" (keyup)="_keyup($event)" 
                    [nzStep]="fcStep"></nz-input-number>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
     `,
    styles: [`
    .fc-readonly {
        pointer-events: none;
    }
    :host ::ng-deep .fc-readonly .ant-input-number-input-wrap{
        background-color: #ccc;
    }
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    .fc-readonly {
        pointer-events: none;
        background:#f5f5f5;
    }
    :host ::ng-deep .fc-readonly .ant-input-number-input{
        background: #f5f5f5;
    }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcdoubleComponent),
        multi: true
    }]
})
export class FcdoubleComponent extends FcinputComponent {
     /** æå¤§å¼*/
    @Input()
    fcMaxValue: string;
    _maxValue: number;
     /** æå°å¼*/
    @Input()
    fcMinValue: string;
    _minValue: number;
     /** æ­¥æ°*/
    @Input()
    fcStep: number = 0.01;
     /**æ ¼å¼å*/
    @Input()
    fcFormat: string;
     /**ç²¾åº¦*/
    fcPrecision: number;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-double');
        if (this.fcPlaceHolder === undefined) {
            this.fcPlaceHolder = '';
        }
    }
    _afterParentInit() {
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        }else{
            this._disabled = false;
        }
         /**æ¯å¦åªè®*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        }else{
            this._readonly = false;
        }
         /**æå¤§å¼*/
        if (this.fcMaxValue !== undefined) {
            this._maxValue = Number(this.fcMaxValue);
        }
         /**æå°å¼*/
        if (this.fcMinValue !== undefined) {
            this._minValue = Number(this.fcMinValue);
        }
    }
}
